import { CompetentionsTable } from './CompetentionsTable';

export default CompetentionsTable;